import React, {Component} from 'react';
import {Company} from '@prisma/client';
import {
  Box,
  Fade,
  FormGroup,
  FormLabel,
  IconButton,
  Modal,
  Paper,
  TextField,
  Typography,
  Unstable_Grid2 as Grid,
  Alert, Snackbar,
} from '@mui/material';
import {Close, SaveAs} from '@mui/icons-material';
import './CreateCompanyModal.scss';
import {LoadingButton} from '@mui/lab';
import {createCompany} from 'services/knestKontrol';

type State = {
  newCompany: Partial<Company>
  loading: boolean,
  snackbarOpen: boolean,
  snackbarSeverity: 'success' | 'error' | 'warning' | 'info',
  snackbarMessage: string,
};

type Props = {
  open: boolean,
  onClose: (createdCompany?: Company & { companyCompanyFeatures: Array<any> } | null) => void,
};

class CreateCompanyModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      newCompany: {},
      loading: false,
      snackbarOpen: false,
      snackbarSeverity: 'success',
      snackbarMessage: '',
    };
  }

  async componentDidMount() {}

  componentDidUpdate(prevProps: Props) {
    if (prevProps.open !== this.props.open && !this.props.open) {
      this.setState({newCompany: {}, loading: false});
    }
  }

  createCompany = async () => {
    this.setState({loading: true});

    try {
      const createdCompany = await createCompany(this.state.newCompany);
      this.setState({
        snackbarOpen: true,
        snackbarSeverity: 'success',
        snackbarMessage: 'Company created successfully.',
      });

      this.props.onClose({
        ...createdCompany,
        companyCompanyFeatures: [],
      });
    } catch (err) {
      console.error(err);
      this.setState({snackbarOpen: true, snackbarSeverity: 'error', snackbarMessage: 'An error occurred while creating the company.'});
    }

    this.setState({loading: false});
  };

  render() {
    const {open} = this.props;
    return <Modal open={open} closeAfterTransition={true} className={'create-company-modal-root'}>
      <Fade in={open} timeout={250}>
        <div className={'create-company-modal'}>
          <Paper className={'create-company-modal-paper'}>
            <IconButton
              size={'small'}
              className={'close-create-company-modal-button'}
              onClick={() => this.props.onClose(null)}
            >
              <Close />
            </IconButton>
            <Box className={'create-company-modal-content'}>
              <Box>
                <Grid container>
                  <Grid xs={12}><Typography variant={'h6'}>Creating Company</Typography></Grid>
                </Grid>
              </Box>
              <Box width={'100%'} height={'calc(100% - 60px)'} overflow={'scroll'} pt={2} pb={2}>
                <Grid container width={'100%'} spacing={2}>
                  <Grid xs={12}>
                    <FormGroup>
                      <FormLabel>
                        Company Name
                      </FormLabel>
                      <TextField
                        value={this.state.newCompany.companyName || ''}
                        size={'small'}
                        disabled={this.state.loading}
                        onChange={event => this.setState({newCompany: {...this.state.newCompany, companyName: event.target.value}})}
                      />
                    </FormGroup>
                  </Grid>
                  <Grid xs={12}>
                    <FormGroup>
                      <FormLabel>
                        Order Confirmation Email
                      </FormLabel>
                      <TextField
                        type={'email'}
                        value={this.state.newCompany.orderConfirmationEmail || ''}
                        size={'small'}
                        disabled={this.state.loading}
                        onChange={event => this.setState({newCompany: {...this.state.newCompany, orderConfirmationEmail: event.target.value}})}
                      />
                    </FormGroup>
                  </Grid>
                  <Grid xs={12}>
                    <FormGroup>
                      <FormLabel>
                        Invoice Email
                      </FormLabel>
                      <TextField
                        type={'email'}
                        value={this.state.newCompany.invoiceEmail || ''}
                        size={'small'}
                        disabled={this.state.loading}
                        onChange={event => this.setState({newCompany: {...this.state.newCompany, invoiceEmail: event.target.value}})}
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
              </Box>
              <Box height={'24px'}>
                <Grid container justifyContent={'flex-end'} spacing={1}>
                  <Grid xs={'auto'}>
                    <LoadingButton
                      loading={this.state.loading}
                      variant={'contained'}
                      color={'primary'}
                      loadingPosition={'start'}
                      startIcon={<SaveAs />}
                      sx={{color: 'white'}}
                      onClick={() => this.createCompany()}
                      disabled={!this.state.newCompany.companyName}
                    >
                      Create Company
                    </LoadingButton>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Paper>
          <Snackbar
            open={this.state.snackbarOpen}
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            autoHideDuration={4000}
            onClose={(_event, reason) => reason !== 'clickaway' && this.setState({snackbarOpen: false})}
          >
            <Alert onClose={() => this.setState({snackbarOpen: false})} severity={this.state.snackbarSeverity} sx={{width: '100%'}}>
              {this.state.snackbarMessage}
            </Alert>
          </Snackbar>
        </div>
      </Fade>
    </Modal>;
  }
}

export default CreateCompanyModal;
